export default __webpack_public_path__ + "static/media/brake.5d5b40a7.png";